import DateTitleWithCost from './styled';

export default DateTitleWithCost;
